export { default as RichText } from './RichText';
export type { Props as RichTextProps } from './RichText';
